import { Box, Typography } from '@mui/material';
import ReusableModal from '../../../../v2/MUI_custom_component/Modal/CustomModal';
import GlassModal from '../../../../v2/MUI_custom_component/Modal/GlassModal';

const TncModal = ({ open, onClose, tnc = [] }) => {
  return (
    <GlassModal
      open={open}
      onClose={onClose}
      title="Terms and Conditions"
      maxWidth="800px"
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {tnc.map((section) => (
          <Box key={section.section_id} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box key={section.section_id} sx={{ display: "flex", gap: 1 }}>
              <Typography variant="body1">{section.section_id}.</Typography>
              <Typography variant="body1">{section.title}</Typography>
            </Box>
            {section.subsections?.map((subsection) => (
              <Box key={subsection.id} sx={{ pl: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box key={subsection.id} sx={{ display: "flex", gap: 1 }}>
                  <Typography variant="body1">{subsection.id}</Typography>
                  <Typography variant="body1">{subsection.text}</Typography>
                </Box>
                {Array.isArray(subsection.notes) && subsection.notes.length > 0 && (
                  <Box component="ul" sx={{ m: 0, pl: 4 }}>
                    {subsection.notes.map((note, idx) => (
                      <Typography
                        component="li"
                        variant="body1"
                        key={idx}
                        sx={{ display: 'list-item', listStyleType: 'disc' }}
                      >
                        {note}
                      </Typography>
                    ))}
                  </Box>
                )}
              </Box>
            ))}
          </Box>
        ))}
      </Box>
    </GlassModal>
  );
};

export default TncModal;
